import React from "react";
import { ReferencePickerPlugin } from "@adsk/acc-reference-picker";
import { useCurrentToolId } from "@adsk/alloy-provider";
import { IssueCreationModal } from "../issue-creation-components/IssueCreationModal";
import { Issue } from "@adsk/acc-issues-types";
import { TOOL_ID_TO_RP_CONTEXT_TYPE } from "./constants";

// the only thing the following crazy type does is look into the ReferencePickerPlugin type
// to get the props interface for CreateNewEntityPanel.
// "NonNullable" just deals with the fact that CreateNewEntityPanel is optional,
// and "Parameters" gets the parameters of the CreateNewEntityPanel function
export type CreateNewEntityPanelProps = Parameters<
  NonNullable<ReferencePickerPlugin<Issue>["CreateNewEntityPanel"]>
>[0] & {
  fixedTypeId?: string;
};

export const CreateNewEntityPanel: ReferencePickerPlugin<Issue>["CreateNewEntityPanel"] =
  ({
    onClose,
    onCreateSuccess,
    open,
    fixedTypeId,
    sourceMetadata,
  }: CreateNewEntityPanelProps) => {
    const toolId = useCurrentToolId();
    const rpContextType = toolId ? TOOL_ID_TO_RP_CONTEXT_TYPE[toolId] : null;

    return (
      <IssueCreationModal
        isOpen={open}
        onClose={onClose}
        analyticsData={{ referencePicker: rpContextType || "unknown" }}
        onCreate={(newItem: Issue) => {
          onCreateSuccess(newItem);
        }}
        fixedTypeId={fixedTypeId}
        locationId={sourceMetadata?.locationId}
      />
    );
  };
